module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_editor') === -1) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "md": 4,
      "lg": 8
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addPackagePromotion
    }
  }, [_vm._v("添加组合促销")])], 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "全部",
      "name": "all"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "待开始",
      "name": "waiting"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "进行中",
      "name": "ongoing"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已结束",
      "name": "end"
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "element-loading-text": "数据加载中"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "package_id",
      "width": "60",
      "label": "编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "package_name",
      "label": "组合促销名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "开始时间",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.start_time, 'yyyy-MM-dd hh:mm:ss')))])]
      }
    }], null, false, 1408255640)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "结束时间",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.end_time, 'yyyy-MM-dd hh:mm:ss')))])]
      }
    }], null, false, 1851373527)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "类型",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 'waiting') ? _c('span', [_vm._v("待开始")]) : _vm._e(), _vm._v(" "), (scope.row.status == 'ongoing') ? _c('span', [_vm._v("进行中")]) : _vm._e(), _vm._v(" "), (scope.row.status == 'end') ? _c('span', [_vm._v("已结束")]) : _vm._e()]
      }
    }], null, false, 2871373959)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operating-icons"
        }, [(scope.row.status == 'ongoing') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.closePackagePromotion(scope.row)
            }
          }
        }, [_vm._v("取消\n                            ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.showPackagePromotion(scope.row)
            }
          }
        }, [_vm._v("查看")]), _vm._v(" "), (scope.row.status == 'waiting') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.updatePackagePromotion(scope.row)
            }
          }
        }, [_vm._v("编辑\n                            ")]) : _vm._e()], 1)]
      }
    }], null, false, 2897986390)
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2cd042c4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cd042c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/promotions/package/list.vue
// module id = 2576
// module chunks = 0